import { connect } from 'react-redux'
import { clearAlerts, removeAlert } from '../actions/alertActions'
import AlertList from '../components/AlertList'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

@connect(
  mapStateToProps,
  { clearAlerts, removeAlert }
)
export default class AlertListContainer extends Component {
  static propTypes = {
    alerts: PropTypes.array.isRequired,
    clearAlerts: PropTypes.func.isRequired,
    clearOnUnmount: PropTypes.bool,
    removeAlert: PropTypes.func.isRequired,
    scope: PropTypes.string
  }

  componentWillUnmount() {
    const { clearAlerts, clearOnUnmount } = this.props
    if (clearOnUnmount) {
      clearAlerts()
    }
  }

  render() {
    const { removeAlert, scope } = this.props
    let { alerts } = this.props

    if (scope) {
      alerts = alerts.filter(alert => alert.scope === scope)
    }

    return <AlertList alerts={alerts} onCloseClick={removeAlert} />
  }
}

function mapStateToProps(state) {
  return {
    alerts: state.alerts
  }
}



// WEBPACK FOOTER //
// ../src/containers/AlertListContainer.js